const data = {
  func: {
    mainTitle: "简单而友好的前端研发体系",
    subTitle: "海量可复用物料，搭配可视化工具极速构建前端应用",
    backtitle: "JDWork",
    bottomIconUrl:
      "https://img10.360buyimg.com/imagetools/jfs/t1/66671/12/9492/82621/5d75f3adE1936f404/26712278fd540081.png",
    backIcon:
      "https://img14.360buyimg.com/imagetools/jfs/t1/52503/14/9050/16478/5d688ce3E4d707f91/97869098cf20eeeb.png",
    backImageUrl:
      "https://img14.360buyimg.com/imagetools/jfs/t1/50758/23/9124/34398/5d6881dfE39fe8027/07b2e77232ccff9f.jpg",
  },
  style: {
    isShowSubTitle: "show",
    wrapPadding: { unit: 2, quantity: "px" },
    backColor: "#dddddd",
    titlePosition: ["center"],
  },
  data: {
    event: { type: "out", filter: "() => {}" },
    getData: {
      type: "local",
      data: {
        data: [
          { title: "可视化开发", subtitle: "简化前端工程复杂度" },
          { title: "丰富的物料", subtitle: "物料拼装提高项目开发效率" },
          {
            title: "最佳实践",
            subtitle: "结合丰富的经验沉淀出的项目开发最佳实践",
          },
          {
            title: "自定义物料",
            subtitle: "通过物料开发者工具快速开发构建私有物料体系",
          },
          {
            title: "多模版支持",
            subtitle: "支持React、Vue、Angular等框架模版",
          },
          {
            title: "数据灵活配置",
            subtitle: "Json Schema自定义数据可灵活配置页面展示",
          },
        ],
      },
      filter: "() => {}",
    },
  },
};
export default data;
